<template>
  <div id="app">
    <div class="rel-position">
      <svg
        :class="this.slideFormOne"
        id="form-one"
        xmlns="http://www.w3.org/2000/svg"
        width="1017.219"
        height="1027.494"
        viewBox="0 0 1017.219 1027.494"
      >
        <path
          class="svg-color"
          d="M30,190.024C-69.028,559.6,92.172,872.559,293.376,671.355s469.077-99.9,469.077-331.33C762.453,55.547,129.028-179.553,30,190.024Z"
          transform="translate(0 660.304) rotate(-60)"
        />
      </svg>
      <svg
        :class="this.slideFormTwo"
        id="form-two"
        xmlns="http://www.w3.org/2000/svg"
        width="150.873"
        height="179.771"
        viewBox="0 0 150.873 179.771"
      >
        <path
          class="svg-color"
          d="M2.064,96.431c21.906,55.688,175.18,56.611,164.012-43.8C153.289-62.294-20.783,38.34,2.064,96.431Z"
          transform="matrix(0.105, 0.995, -0.995, 0.105, 133.453, 0)"
        />
      </svg>
    </div>
    <div class="rel-position">
      <svg
        :class="this.slideFormThree"
        id="form-three"
        xmlns="http://www.w3.org/2000/svg"
        width="694.439"
        height="798.589"
        viewBox="0 0 694.439 798.589"
      >
        <path
          class="svg-color"
          d="M103.221,173.03C58.2,457.822-52.883,548.735,29.713,635.919c99.046,104.548,457.575-53.061,457.575-337.7C487.288-27.58,148.238-111.762,103.221,173.03Z"
          transform="translate(239.516 0) rotate(21)"
        />
      </svg>
      <svg
        :class="this.slideFormFour"
        id="form-four"
        xmlns="http://www.w3.org/2000/svg"
        width="84.064"
        height="98.992"
        viewBox="0 0 84.064 98.992"
      >
        <path
          class="svg-color"
          d="M236.447,208c17.177,43.668,89.713,78.726,80.955-.011C307.375,117.872,218.532,162.45,236.447,208Z"
          transform="translate(-234.069 -155.812)"
        />
      </svg>
    </div>
    <Logo :width="117" class="logo" :class="this.slideLogo" />
    <div class="title-wrapper" :class="this.slideTitle">
      <Title class="title" />
      <p class="call">Calcule o plano ideal para você!</p>
    </div>
    <div class="form">
      <transition name="fade" mode="out-in">
        <router-view :points="points" :range="range" />
      </transition>
    </div>
    <router-link class="rout" :class="this.hideThis" @click.native="changeToGrid" to="/Form">
      <span class="scrollmsg">
        <span class="link-color">Clique aqui</span> ou role o scroll para começar.
      </span>
      <br />
      <br />
      <br />Próximo
      <br />
      <svg
        class="arrowsvg"
        xmlns="http://www.w3.org/2000/svg"
        width="34"
        height="15"
        viewBox="0 0 34 15"
      >
        <path
          class="svg-arrow"
          d="M15.677,1.168a2,2,0,0,1,2.646,0L30.034,11.5A2,2,0,0,1,28.71,15H5.29a2,2,0,0,1-1.323-3.5Z"
          transform="translate(34 15) rotate(180)"
        />
      </svg>
    </router-link>
  </div>
</template>

<script>
import Logo from "./components/Template/Logo";
import Title from "./components/Template/Title";

export default {
  components: {
    Logo,
    Title
  },

  data() {
    return {
      points: [
        {
          item_name: "people_one",
          item_points: 3
        },
        {
          item_name: "people_two",
          item_points: 4
        },
        {
          item_name: "people_three",
          item_points: 6
        },
        {
          item_name: "people_four",
          item_points: 8
        },
        {
          item_name: "people_five",
          item_points: 10
        },
        {
          item_name: "people_six",
          item_points: 12
        },
        {
          item_name: "device_one",
          item_points: 0
        },
        {
          item_name: "device_two",
          item_points: 0
        },
        {
          item_name: "device_three",
          item_points: 0
        },
        {
          item_name: "device_four",
          item_points: 0
        },
        {
          item_name: "device_five",
          item_points: 0
        },
        {
          item_name: "device_six",
          item_points: 0
        },
        {
          item_name: "service_one",
          item_points: 2
        },
        {
          item_name: "service_two",
          item_points: 2
        },
        {
          item_name: "service_three",
          item_points: 5
        },
        {
          item_name: "service_four",
          item_points: 5
        },
        {
          item_name: "service_five",
          item_points: 3
        },
        {
          item_name: "service_six",
          item_points: 5
        },
        {
          item_name: "VOCÊ Fone Local Fixo Ilimitado",
          item_points: 0
        },
        {
          item_name: "VOCÊ Fone Local Ilimitado",
          item_points: 0
        },
        {
          item_name: "VOCÊ Fone Nacional Fixo Ilimitado",
          item_points: 0
        },
        {
          item_name: "VOCÊ Fone Nacional Ilimitado",
          item_points: 0
        }
      ],
      range: [
        {
          plan_name: "200",
          min_poits: 0,
          max_points: 48
        },
        {
          plan_name: "300",
          min_poits: 49,
          max_points: 88
        },
        {
          plan_name: "400",
          min_poits: 89,
          max_points: 132
        },
        {
          plan_name: "500",
          min_poits: 133,
          max_points: 176
        },
        {
          plan_name: "750",
          min_poits: 177,
          max_points: 220
        },
        {
          plan_name: "1000",
          min_poits: 221,
          max_points: 264
        }
      ],
      slideTitle: "",
      slideLogo: "",
      slideFormOne: "",
      slideFormTwo: "",
      slideFormThree: "",
      slideFormFour: "",
      hideThis: ""
    };
  },

  methods: {
    changeToGrid() {
      (this.slideTitle = "title-animation"),
        (this.slideLogo = "logo-animation"),
        (this.slideFormOne = "slide-form-one"),
        (this.slideFormTwo = "slide-form-two"),
        (this.slideFormThree = "slide-form-three"),
        (this.slideFormFour = "slide-form-four"),
        (this.hideThis = "hide-this");
        document.querySelector(".rout").remove()
    },
    // fetchPoints() {
    //     fetch("http://localhost:3333/config_items")
    //         .then(r => r.json())
    //         .then(r => {
    //             const parseobj = JSON.parse(JSON.stringify(r));

    //             this.points = r;
    //             console.log(r);
    //         });
    // },
    // fetchRange() {
    //     fetch("http://localhost:3333/config_range")
    //         .then(r => r.json())
    //         .then(r => {
    //             const parseobj = JSON.parse(JSON.stringify(r));

    //             this.range = r;
    //             console.log(r);
    //         });
    // }
    wheelAction() {
        const click_event = new CustomEvent("click");
        const btn_element = document.querySelector(".rout");
        btn_element.dispatchEvent(click_event);
    }
  },
  created() {
    // this.fetchPoints();
    // this.fetchRange();
    document.body.addEventListener(
      "wheel",
      this.wheelAction
    );
  },
  mounted() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js"
    );
    document.head.appendChild(recaptchaScript);
    const scriptLoader = document.createElement("script");
    scriptLoader.setAttribute(
      "src",
      "https://d335luupugsy2.cloudfront.net/js/loader-scripts/4d86bade-9341-43c4-a5c1-b4c8384a9b64-loader.js"
    );
    document.body.appendChild(scriptLoader);
  }
};
</script>

<style lang="scss">
@import "./styles/style";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: transparent $gradient-orange 0% 0% no-repeat padding-box;
  height: 100vh;
  overflow: hidden;
  padding: 2rem 4rem;
  transition: ease 0.4s;

  flex-direction: column;
  justify-content: space-around;
  display: flex;

  #rd-column-kl2qrifs {
    display: none;
  }

  #rd-row-kl2qrifr,
  #rd-column-kl2qrifw > div {
    background-color: #fafafa;
    padding: 0;
  }

  #rd-form-kl2qrifx .bricks-form__label {
    color: #ff8412;
  }

  #rd-form-kl2qrifx .bricks-form__input {
    border-radius: 10px;
  }

  #calculadora-nova-5d3cd633c6102a8d675e {
    position: absolute;
    top: 0;
    z-index: -1;
  }

  .title {
    margin: 75px 0;
  }

  .title-wrapper {
    z-index: 2;
  }

  .title-animation {
    animation: movetitle 2s ease-out forwards;
  }

  @keyframes movetitle {
    to {
      transform: translate(-38%, 0%) scale(0.4);
    }
  }

  .logo {
    margin: 0 auto;
  }

  .logo-animation {
    animation: movelogo 2s ease-out forwards;
  }

  @keyframes movelogo {
    to {
      transform: translate(0%, -300%);
    }
  }

  .call {
    text-align: center;
  }

  .rout {
    font-weight: bold;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
    display: inline-block;
    padding: 10px;
    cursor: pointer;
    z-index: 1;
  }
}

.hide-this {
  opacity: 0;
}

a {
  color: $white;
}

a:visited {
  color: $white;
}

a:hover {
  color: $white;
}

a:active {
  color: $white;
}

.svg-color {
  fill: $purple;
  opacity: 0.2;
}

.svg-arrow {
  fill: $white;
}

.rel-position {
  position: relative;
}

#form-one {
  position: absolute;
  right: 50%;
  margin-top: -10%;
}

.slide-form-one {
  animation: move 2s ease-in-out forwards;
}

@keyframes move {
  to {
    transform: translate(-20%, -21%) scale(0.5);
  }
}

#form-two {
  position: absolute;
  margin-top: 40%;
}

.slide-form-two {
  animation: move2 2.5s ease-in-out forwards;
}

@keyframes move2 {
  to {
    transform: translate(-40%, -250%) scale(0.5);
  }
}

#form-three {
  position: absolute;
  right: -5%;
  top: 7em;
}

.slide-form-three {
  animation: move3 2s ease-in-out forwards;
}

@keyframes move3 {
  to {
    transform: translate(25%, 20%) scale(0.5);
  }
}

.slide-form-four {
  animation: move4 2.5s ease-in-out forwards;
}

#form-four {
  position: absolute;
  right: 3em;
  top: em;
}

@keyframes move4 {
  to {
    transform: translate(90%, 420%) scale(0.7);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.7s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.arrowsvg {
  align-self: center;
  margin-top: 1em;
}

.link-color {
  color: #c8a2c8;
}

@media only screen and (max-width: 600px) {
  #app {
    padding: 3rem;

    #calculadora-nova-5d3cd633c6102a8d675e {
      position: relative;
      margin-top: -40px;
    }
  }

  #form-one,
  #form-two,
  #form-three,
  #form-four {
    display: none;
  }

  @keyframes movetitle {
    to {
      visibility: hidden;
    }
  }
}

@media only screen and (min-width: 1200px) {
  @keyframes movetitle {
    to {
      transform: translate(-45%, 0%) scale(0.2);
    }
  }

  @keyframes movelogo {
    to {
      transform: translate(0%, -70%);
    }
  }
}

@media only screen and (min-width: 1800px) {
  @keyframes movetitle {
    to {
      transform: translate(-38%, 0%) scale(0.4);
    }
  }

  @keyframes movelogo {
    to {
      transform: translate(0%, -300%);
    }
  }
}
</style>
